import { Interfaces, Constants } from "@ambifi/ambifi-synthetic-voice";
import uuid from "uuid/v4";
import _ from "lodash";
import { setVoices} from "../../actions/playerActions";

const ENABLE_LOGGING = true;

const { SyntheticVoiceTextToSpeechProvider, SyntheticVoiceProvider } = Interfaces;
const { EVENT_TYPE_SPEECH_START, EVENT_TYPE_SPEECH_FINISH } = Constants;

let SPEECH_VOLUME = 1.0;
let SPEECH_RATE = 1.0;
let SPEECH_PITCH = 1.0;
let SPEECH_LANG = "en-US";
let SPEECH_VOICE = null;

const PROVIDER_VOICE_SPEEDS = {
	[Constants.VOICE_SPEED_SLOWEST]: 0.65,
	[Constants.VOICE_SPEED_SLOWER]: 0.75,
	[Constants.VOICE_SPEED_SLOW]: 0.85,
	[Constants.VOICE_SPEED_NORMAL]: 1.0,
	[Constants.VOICE_SPEED_FAST]: 1.15,
	[Constants.VOICE_SPEED_FASTER]: 1.25,
	[Constants.VOICE_SPEED_FASTEST]: 1.35
};

let voices = [];
function populateVoiceList() {
	if (window.speechSynthesis) {
		voices = window.speechSynthesis.getVoices();
		console.log("Setting voice", voices);
		setVoices(voices);
	}
}

if (window.speechSynthesis && window.speechSynthesis.onvoiceschanged !== undefined) {
	console.log("Voices onchange event registered");
	window.speechSynthesis.onvoiceschanged = populateVoiceList;
} else if (window.speechSynthesis) {
	console.log("Voices onchange event NOT registered");
	try {
		if (window.speechSynthesis) {
			voices = window.speechSynthesis.getVoices();
			console.log("Setting voices", voices);
			setTimeout(() => {
				setVoices(voices);
			},1000);
		}
	} catch (e) {
		console.warn("Unable to set voices", e);
	}
} else {
	console.warn("NO WINDOW SPEECH SYNTHESIS DETECTED");
}

if (window.speechSynthesis) {
	window.speechSynthesis.getVoices();
}
console.log("Voices:", voices);

class TtsProvider extends SyntheticVoiceTextToSpeechProvider {
	constructor() {
		super();
		console.log("TtsProvider: CONSTRUCTOR");
		this.currentSound = null;
		this.paused = false;
		this.guid = uuid();

		this.speech = new SpeechSynthesisUtterance();
		this.speech.volume = SPEECH_VOLUME;
		this.speech.lang = SPEECH_LANG;
		this.speech.rate = SPEECH_RATE;
		this.speech.pitch = SPEECH_PITCH;
		if (SPEECH_VOICE) {
			this.speech.voice = SPEECH_VOICE;
		} else if (this.config && this.config.options && this.config.options.voice && !_.isString(this.config.options.voice)) {
			this.speech.voice = this.config.options.voice;
		}

		this.errorFn = (err) => {
			ENABLE_LOGGING && console.error("SyntheticVoice: TtsNative: error:", err, err.error);
			this._onSpeechEnd(err);
		};
		this._onSpeechStartBound = this._onSpeechStart.bind(this);
		this._onSpeechEndBound = this._onSpeechEnd.bind(this);
		this.errorFnBound = this.errorFn.bind(this);

		this.speech.addEventListener("start", this._onSpeechStartBound);
		this.speech.addEventListener("end", this._onSpeechEndBound);
		this.speech.addEventListener("error", this.errorFnBound);
		// this.pingIntervalId = null;
		this.hasStarted = false;
	}

	_onSpeechStart() {
		ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: START EVENT (Tts) speech request", this);
		this.hasStarted = true;
		this.fireEvent(EVENT_TYPE_SPEECH_START);
	}
	_onSpeechEnd() {
		ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: FINISH EVENT (Tts) speech request", this.pingIntervalId);
		this.speech.removeEventListener("start", this._onSpeechStartBound);
		this.speech.removeEventListener("end", this._onSpeechEndBound);
		this.speech.removeEventListener("error", this.errorFnBound);
		this.fireEvent(EVENT_TYPE_SPEECH_FINISH);
	}

	static getVoices() {
		return voices;
	}

	start(speechRequest) {
		const { text,config } = speechRequest;
		return this.speak(text, config);
	}

	stop() {
		if (window.speechSynthesis && window.speechSynthesis.speaking) {
			window.speechSynthesis.cancel();
		}
	}


	speak(text, config) {
		if (!text || !window.speechSynthesis) {
				this._onSpeechEnd();
				return Promise.resolve();
			}
			return new Promise(async (resolve, reject) => { // eslint-disable-line no-async-promise-executor
				try {

					this.speech.text = text;

					ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: about to speak:", this.guid, text, config, window.speechSynthesis);
					
					if (window.speechSynthesis.speaking) {
						ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: about to speak: not currently speaking", this.guid);
						// SpeechSyn is currently speaking, cancel the current utterance(s)
						window.speechSynthesis.cancel();
						ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: about to speak: cancelled current speech", this.guid);
						const self = this;
						setTimeout(() => {
							ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: about to speak: about to fix voice", this.guid);
							self.fixVoice(config);
							console.log("SyntheticVoice: TtsNative: SPEAK ", self.speech);
							window.speechSynthesis.speak(self.speech);
						}, 250);
					}
					else {
						ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: about to speak: currently speaking", this.guid);
						// Good to go
						ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: about to speak: about to fix voice", this.guid);
						this.fixVoice(config);
						console.log("SyntheticVoice: TtsNative:SPEAK(2) ", this.speech);
						window.speechSynthesis.speak(this.speech);
					}

					resolve(text);
				} catch (e) {
					reject(e);
				}
			});
		
	}

	fixVoice(config) {
		if (config && config.options && config.options.voice && !_.isString(config.options.voice)) {
			this.speech.voice = config.options.voice;
			if (this.speech.lang !== this.speech.voice.lang) {
				this.speech.lang = this.speech.voice.lang;
			}
		} else if (SPEECH_VOICE && this.speech.voice && this.speech.voice.name !== SPEECH_VOICE.name) {
			this.speech.voice = SPEECH_VOICE;
			if (this.speech.lang !== this.speech.voice.lang) {
				this.speech.lang = this.speech.voice.lang;
			}
		} else if (this.config && this.config.options && this.config.options.voice && !_.isString(this.config.options.voice) && this.speech.voice.name !== this.config.options.voice.name) {
			this.speech.voice = this.config.options.voice;
			if (this.speech.lang !== this.speech.voice.lang) {
				this.speech.lang = this.speech.voice.lang;
			}
		}
	}

	static setDefaultSpeed(speed) {
		if (_.isNumber(speed) && _.isNaN(speed)) {
			SPEECH_RATE = 2;
		} else {
			const speedConstant = SyntheticVoiceProvider.getSpeedConstantFromValue(speed);
			console.log("Setting speech rate", speed, PROVIDER_VOICE_SPEEDS[speedConstant]);
			SPEECH_RATE = PROVIDER_VOICE_SPEEDS[speedConstant];
		}
	}
	static setDefaultLanguage(lang) {
		SPEECH_LANG = lang;
	}
	static setDefaultVoice(voice) {
		ENABLE_LOGGING && console.log("SyntheticVoice: TtsNative: setDefaultVoice:", voice);
		SPEECH_VOICE = voice;
	}
}

export default TtsProvider;